import { mapState } from 'vuex';
import { FeedbackForm } from 'ipro-ui-kit-vuejs/src/components';

import { FeedbackService } from '@/core/feedback';

// @vue/component
export default {
  components: {
    FeedbackForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitInProgress: false,
    };
  },
  computed: {
    ...mapState(['pageTitle']),
    showAsBottomSheet() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showing: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    metadata() {
      return {
        url: window.location.href,
        title: this.pageTitle,
        params: this.$route.params,
        query: this.$route.query,
        userAgent: navigator.userAgent,
      };
    },
  },
  watch: {
    showing(newValue) {
      if (!newValue) {
        this.$refs.feedbackForm.reset();
      }
    },
  },
  methods: {
    async submit(feedback) {
      this.submitInProgress = true;
      try {
        await FeedbackService.create(_.extend({
          page_url: this.$route.name,
          metadata: this.metadata,
        }, feedback));
      } catch (error) {
        // do nothing
      }

      this.submitInProgress = false;
      this.showing = false;
    },
  },
};
